import { Button, Form, Spinner } from 'react-bootstrap';
import { ChevronRight } from 'react-feather';

import BankIDIcon from '../../assets/img/bankID-logo.svg';
import { GrandIDAuthStatus } from '../../types/auth';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';

interface Props {
  verificationStatus: GrandIDAuthStatus;
  onRetrySignIn: () => void;
}

function DesktopVerification({ verificationStatus, onRetrySignIn }: Props) {

  const { t, i18n } = useTranslation();

useEffect(() => {
  if (i18n.language !== 'se') {
    i18n.changeLanguage('se');
  }
}, []);
  return (
    <>
      <div className="bankid-desktop-verification">
        <Form.Label className="fs-h3 font-black d-flex">{t('Sign_in_with_your_BankID')}</Form.Label>
        {verificationStatus === GrandIDAuthStatus.PENDING && (
          <div className="verification-content">
            <div className="img-holder">
              <img src={BankIDIcon} alt="" />
            </div>
            <div className="loading-status">
              <div className="loading-status--text theme-text">Skriv in din säkerhetskod i BankID- appen.</div>
              <Spinner className="loading-status--spinner" />
            </div>
            {/* <Button onClick={() => onRetrySignIn()} className="app-btn-primary">
              Start the BankID app manually
            </Button> */}
          </div>
        )}

        {verificationStatus === GrandIDAuthStatus.FAILED && (
          <>
            <div className="theme-text mb-3 mt-3">
             {t('The_BankID_app_doesnt')}
             
            </div>
            <div className="d-flex justify-content-center">
              <Button onClick={() => onRetrySignIn()} style={{ textAlign: 'left' }} className="app-btn-primary">
                <ChevronRight /> {t('try_again')}
              </Button>
            </div>
          </>
        )}
      </div>
    </>
  );
}

export default DesktopVerification;
